import { Component, inject, OnInit, OnDestroy } from '@angular/core';
import {
  ChangePasswordComponent
} from '@pages/users/user-profile/user-profile/account/change-password/change-password.component';
import {
  PersonalDetailsComponent
} from '@pages/users/user-profile/user-profile/account/personal-details/personal-details.component';
import {
  UserProfileImageComponent
} from '@pages/users/user-profile/user-profile/account/user-profile-image/user-profile-image.component';
import {MaterialModule} from '@app/material.module';
import { TablerIconsModule } from 'angular-tabler-icons';
import {User} from '@interfaces/user';
import {Subject, takeUntil} from 'rxjs';
import {AuthService} from '@services/api/auth/auth.service';

@Component({
  selector: 'app-account',
  imports: [
    ChangePasswordComponent,
    PersonalDetailsComponent,
    UserProfileImageComponent,
    MaterialModule,
    TablerIconsModule
  ],
  templateUrl: './account.component.html',
  standalone: true,
  styleUrl: './account.component.scss'
})
export class AccountComponent implements OnInit, OnDestroy {
  private user_api_service = inject(AuthService);
  protected user: User | null = null;
  private destroy$ = new Subject<void>();

  constructor() {
  }

  ngOnInit(): void {
    this.user_api_service.get_user_data()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          this.user = response.data;
        },
        error: (error) => {
          console.error(error);
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
